import { createStore, applyMiddleware,combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import ProductionListReducer from 'reducers/ProductionListReducer';
import SettingsReducer from 'reducers/SettingsReducer';
import ProductionSummaryReducer from 'reducers/ProductionSummaryReducer';
import ErrorReducer from 'reducers/ErrorReducer';
import BaseActionCreator from 'actions/BaseActionCreator';

const rootReducer = combineReducers({
	ProductionListReducer,
	SettingsReducer,
	ProductionSummaryReducer,
	ErrorReducer
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState) {
  return createStore(rootReducer,
		  initialState,
		  composeEnhancers(
				applyMiddleware(
				  thunk
	      )
			),
	);
}
export const GlobalStore = configureStore();
BaseActionCreator.setDispatcher(GlobalStore);



// WEBPACK FOOTER //
// ./src/scripts/reducers/configureStore.js